import client from './client'

export const getResourceCity = async (resource, id) => {
  const resourceResponse = await client.get(`${resource}/${id}`)
  const community = await client.get(`communities/${resourceResponse.community_id}`)
  return client.get(`cities/${community.city_id}`)
}
